import React, { createContext, useContext } from "react";

const WorkspaceBrandContext = createContext({
  workspace: { name: "Gray Owl", tagline: "Workspace", logo_url: "" },
  openBrandEditor: () => {},
});

export const WorkspaceBrandProvider = WorkspaceBrandContext.Provider;
export const useWorkspaceBrand = () => useContext(WorkspaceBrandContext);
